export const MIN_AGE = 18
export const MAX_AGE = 100

export const MAX_WEIGHT_KG = 189
export const MAX_WEIGHT_LBS = 415
export const MIN_WEIGHT_KG = 30
export const MIN_WEIGHT_LBS = 66

const validRanges = {
  heightCm: {
    min: 122,
    max: 231,
  },
  heightFt: {
    min: 4,
    max: 7,
  },
  heightIn: {
    min: 0,
    max: 11,
  },
  weightKg: {
    min: 30,
    max: 300,
  },
  weightLbs: {
    min: 66,
    max: 660,
  },
}

const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

const isString = (value) => typeof value === "string"

const validateMinMax = ({ value, min, max }) => Number(value) >= min && Number(value) <= max

const heightCm = (value, store) => {
  const isValid = validateMinMax({ value, ...validRanges["heightCm"] })
  const isSkipped = store.values.measurementSystem === "imperial"

  return isValid || isSkipped
}

const heightFt = (value, store) => {
  const isValid = validateMinMax({ value, ...validRanges["heightFt"] })
  const isSkipped = store.values.measurementSystem === "metric"

  return isValid || isSkipped
}

const heightIn = (value, store) => {
  const isValid = validateMinMax({ value, ...validRanges["heightIn"] })
  const isSkipped = store.values.measurementSystem === "metric"

  return isValid || isSkipped
}

const weightKg = (value, store) => {
  const isValid = validateMinMax({ value, ...validRanges["weightKg"] })
  const isSkipped = store.values.measurementSystem === "imperial"

  return isValid || isSkipped
}

const weightLbs = (value, store) => {
  const isValid = validateMinMax({ value, ...validRanges["weightLbs"] })
  const isSkipped = store.values.measurementSystem === "metric"

  return isValid || isSkipped
}

const targetWeightLbs = (value, store) => {
  const isValid = validateMinMax({ value, ...validRanges["weightLbs"] })
  const isSkipped = store.values.measurementSystem === "metric"

  return isValid || isSkipped
}

const targetWeightKg = (value, store) => {
  const isValid = validateMinMax({ value, ...validRanges["weightKg"] })
  const isSkipped = store.values.measurementSystem === "imperial"

  return isValid || isSkipped
}

const validators = {
  measurementSystem: (value) => ["imperial", "metric"].includes(value),
  heightCm,
  heightFt,
  heightIn,
  email: (value) => isString(value) && value.match(EMAIL_REGEX),
  age: (value) => Number(value) >= MIN_AGE && Number(value) <= MAX_AGE,
  weightKg,
  weightLbs,
  targetWeightKg,
  targetWeightLbs
}

const ERROR_MESSAGES = new Proxy(
  {
    age: "errors.age",
    email: "errors.email",
    heightCm: "errors.heightCm",
    heightFt: "errors.heightFt",
    heightIn: "errors.heightIn",
    weightKg: "errors.weightKg",
    weightLbs: "errors.weightLbs",
  },
  {
    get: (target, name) => (target.hasOwnProperty(name) ? target[name] : "invalid"),
  },
)

const validate = (formValues, store) => {
  const errors = {}
  let hasErrors = false

  Object.entries(formValues).forEach(([field, value]) => {
    const validator = validators[field]

    if (validator && !validator(value, store)) {
      hasErrors = true
      errors[field] = ERROR_MESSAGES[field]
    }
  })

  return { hasErrors, errors }
}

export default validate
